import { render, staticRenderFns } from "./AcknowledgeProblem.vue?vue&type=template&id=3f31a07d&"
import script from "./AcknowledgeProblem.vue?vue&type=script&lang=js&"
export * from "./AcknowledgeProblem.vue?vue&type=script&lang=js&"
import style0 from "./AcknowledgeProblem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports